import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_generation, use_slice_grid2d, use_slice_ui } from '@/hooks/store/use_slices';
import { store_local__ui_set_string } from '@/state/ui/_base/LOCAL__ui_set_string';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { ENUM__page_generation_layout } from '../../_enums/ENUM__page_generation_layout';

export function WATCHER__generation_consume_content_reset() {
  const { grids2d_map } = use_slice_grid2d(['grids2d_map']);
  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_grid2d__consume__hash_sha256_content, g_general__layout, global__page_type } = use_slice_ui([
    'g_grid2d__consume__hash_sha256_content',
    'g_general__layout',
    'global__page_type',
  ]);

  use_effect(() => {
    if (!global__page_type.includes(ENUM__page_type.GENERATION_WITHOUT_PARAMS)) return try_reset_consume_field();
    if (g_general__layout != ENUM__page_generation_layout.OUTPUTS) return try_reset_consume_field();
    if (generation_current.is_stub()) return try_reset_consume_field();
    if (generation_current.graph_field_consumer.is_stub()) return try_reset_consume_field();

    if (!grids2d_map.has(generation_current._id)) return try_reset_consume_field();

    let grid2d = grids2d_map.get_or_assert(generation_current._id);
    let cell_in_grid = grid2d.cells__get_loaded().some(cell => cell.hash_sha256_content == g_grid2d__consume__hash_sha256_content);
    if (!cell_in_grid) return try_reset_consume_field();
  }, [generation_current]);

  function try_reset_consume_field() {
    if (g_grid2d__consume__hash_sha256_content.is_empty_hash_sha256()) return;

    store_local__ui_set_string({ key: 'g_grid2d__consume__hash_sha256_content', value: ENUM__string_id_empty.HASH_SHA256, valid_values: [] });
  }

  return null;
}
